import React, { useContext, useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FiUser, FiLogOut, FiSettings, FiUsers, FiCalendar, FiMenu } from 'react-icons/fi';
import { FaRoute, FaFileInvoiceDollar, FaMapMarkerAlt, FaMoneyBillWave, FaBus } from 'react-icons/fa';
import { MdDirectionsBus } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from '../AppContext';
import LogoutModal from '../components/LogoutModal';
import { tre } from '../trebus';

export default function Header() {
    const context = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const go = (dir) => navigate(dir);

    const goHome = () => {
        if (context?.user) {
            navigate(context.user.role === 'USER' ? '/calendar' : '/journey');
        }
    };

    const handleLogout = () => {
        tre.api('PUT', '/logout', {
            context: context,
            success: () => {
                navigate('/login');
                context.setUser({});
                setShowLogoutModal(false);
            }
        });
    };

    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

    return (
        <AppContext.Consumer>
            {({ user }) => (
                <>
                    <Navbar
                        expand="lg"
                        className="fixed-top"
                        style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 2px 20px rgba(0,0,0,0.15)',
                            zIndex: 1030
                        }}
                    >
                        <Container>
                            <Navbar.Brand
                                role="button"
                                onClick={goHome}
                                className="d-flex align-items-center py-1"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                    style={{
                                        width: '38px',
                                        height: '38px',
                                        backgroundColor: 'rgba(255,255,255,0.2)'
                                    }}
                                >
                                    <MdDirectionsBus className="text-white" style={{ fontSize: '22px' }} />
                                </div>
                                <span className="fw-bold text-white" style={{ fontSize: '1.25rem', letterSpacing: '1px' }}>
                                    BOLEBUS
                                </span>
                            </Navbar.Brand>

                            <Navbar.Toggle
                                aria-controls="main-navbar"
                                className="border-0 shadow-none"
                                style={{ color: 'white' }}
                            >
                                <FiMenu className="text-white" style={{ fontSize: '24px' }} />
                            </Navbar.Toggle>

                            <Navbar.Collapse id="main-navbar">
                                {user?.id && (
                                    <>
                                        <Nav className="me-auto">
                                            {(user.role === 'ADMIN' || user.role === 'DRIVER') && (
                                                <>
                                                    {/* Viajes - Direct link for drivers */}
                                                    <Nav.Link
                                                        onClick={() => go('/journey')}
                                                        className={`text-white d-flex align-items-center mx-1 px-3 py-2 rounded ${isActive('/journey') || isActive('/trip') ? 'bg-white bg-opacity-25' : ''}`}
                                                        style={{ transition: 'background 0.2s' }}
                                                    >
                                                        <FaBus className="me-2" />
                                                        Viajes
                                                    </Nav.Link>

                                                    {/* Usuarios */}
                                                    <NavDropdown
                                                        title={<span className="text-white d-flex align-items-center"><FiUsers className="me-2" />Usuarios</span>}
                                                        id="users-dropdown"
                                                        className="nav-dropdown-custom mx-1"
                                                    >
                                                        <NavDropdown.Item onClick={() => go('/users')}>
                                                            <FiUsers className="me-2 text-primary" />Lista de Usuarios
                                                        </NavDropdown.Item>
                                                        {user.role === 'ADMIN' && (
                                                            <>
                                                                <NavDropdown.Divider />
                                                                <NavDropdown.Item onClick={() => go('/month')}>
                                                                    <FaFileInvoiceDollar className="me-2 text-primary" />Resumen del Mes
                                                                </NavDropdown.Item>
                                                            </>
                                                        )}
                                                        <NavDropdown.Item onClick={() => go('/calendar')}>
                                                            <FiCalendar className="me-2 text-primary" />Calendario
                                                        </NavDropdown.Item>
                                                    </NavDropdown>

                                                    {user.role === 'ADMIN' && (
                                                        <>
                                                            {/* Rutas */}
                                                            <NavDropdown
                                                                title={<span className="text-white d-flex align-items-center"><FaRoute className="me-2" />Rutas</span>}
                                                                id="routes-dropdown"
                                                                className="nav-dropdown-custom mx-1"
                                                            >
                                                                <NavDropdown.Item onClick={() => go('/routes')}>
                                                                    <FaRoute className="me-2 text-primary" />Gestionar Rutas
                                                                </NavDropdown.Item>
                                                                <NavDropdown.Item onClick={() => go('/discrecionals')}>
                                                                    <FaBus className="me-2 text-primary" />Discrecionales
                                                                </NavDropdown.Item>
                                                                <NavDropdown.Divider />
                                                                <NavDropdown.Item onClick={() => go('/stops')}>
                                                                    <FaMapMarkerAlt className="me-2 text-primary" />Paradas
                                                                </NavDropdown.Item>
                                                                <NavDropdown.Item onClick={() => go('/rates')}>
                                                                    <FaMoneyBillWave className="me-2 text-primary" />Tarifas
                                                                </NavDropdown.Item>
                                                            </NavDropdown>

                                                            {/* Contabilidad */}
                                                            <NavDropdown
                                                                title={<span className="text-white d-flex align-items-center"><FaFileInvoiceDollar className="me-2" />Contabilidad</span>}
                                                                id="accounting-dropdown"
                                                                className="nav-dropdown-custom mx-1"
                                                            >
                                                                <NavDropdown.Item onClick={() => go('/payments')}>
                                                                    <FaMoneyBillWave className="me-2 text-primary" />Cobros
                                                                </NavDropdown.Item>
                                                                <NavDropdown.Item onClick={() => go('/driver-payments')}>
                                                                    <FiUsers className="me-2 text-primary" />Cobros por Conductor
                                                                </NavDropdown.Item>
                                                                <NavDropdown.Divider />
                                                                <NavDropdown.Item onClick={() => go('/invoices')}>
                                                                    <FaFileInvoiceDollar className="me-2 text-primary" />Facturas
                                                                </NavDropdown.Item>
                                                                <NavDropdown.Item onClick={() => go('/customers')}>
                                                                    <FiUsers className="me-2 text-primary" />Clientes
                                                                </NavDropdown.Item>
                                                            </NavDropdown>

                                                            {/* Sistema */}
                                                            <Nav.Link
                                                                onClick={() => go('/conf')}
                                                                className={`text-white d-flex align-items-center mx-1 px-3 py-2 rounded ${isActive('/conf') ? 'bg-white bg-opacity-25' : ''}`}
                                                            >
                                                                <FiSettings className="me-2" />
                                                                Config
                                                            </Nav.Link>
                                                        </>
                                                    )}
                                                </>
                                            )}

                                            {user.role === 'USER' && (
                                                <Nav.Link
                                                    onClick={() => go('/calendar')}
                                                    className="text-white d-flex align-items-center mx-1 px-3 py-2 rounded bg-white bg-opacity-25"
                                                >
                                                    <FiCalendar className="me-2" />
                                                    Mi Calendario
                                                </Nav.Link>
                                            )}
                                        </Nav>

                                        {/* User info and logout */}
                                        <Nav className="align-items-lg-center">
                                            <div
                                                className="d-flex align-items-center px-3 py-2 rounded me-lg-2 my-2 my-lg-0"
                                                style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
                                            >
                                                <FiUser className="text-white me-2" />
                                                <span className="text-white fw-medium">{user.full_name}</span>
                                            </div>
                                            <Nav.Link
                                                onClick={() => setShowLogoutModal(true)}
                                                className="d-flex align-items-center px-3 py-2 rounded text-white"
                                                style={{
                                                    backgroundColor: 'rgba(220,53,69,0.8)',
                                                    transition: 'background 0.2s'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(220,53,69,1)'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(220,53,69,0.8)'}
                                            >
                                                <FiLogOut className="me-2" />
                                                Salir
                                            </Nav.Link>
                                        </Nav>
                                    </>
                                )}
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>

                    <LogoutModal
                        show={showLogoutModal}
                        handleClose={() => setShowLogoutModal(false)}
                        handleLogout={handleLogout}
                    />

                    {/* Custom styles for dropdowns */}
                    <style>{`
                        .nav-dropdown-custom .dropdown-toggle {
                            display: flex !important;
                            align-items: center;
                            color: white !important;
                            padding: 8px 12px;
                            border-radius: 6px;
                            transition: background 0.2s;
                        }
                        .nav-dropdown-custom .dropdown-toggle:hover,
                        .nav-dropdown-custom.show .dropdown-toggle {
                            background: rgba(255,255,255,0.2);
                        }
                        .nav-dropdown-custom .dropdown-toggle::after {
                            color: white;
                            margin-left: 6px;
                            vertical-align: middle;
                        }
                        .nav-dropdown-custom .dropdown-toggle > span {
                            display: flex;
                            align-items: center;
                        }
                        .nav-dropdown-custom .dropdown-menu {
                            border: none;
                            border-radius: 10px;
                            box-shadow: 0 10px 40px rgba(0,0,0,0.15);
                            padding: 8px;
                            margin-top: 8px;
                        }
                        .nav-dropdown-custom .dropdown-item {
                            border-radius: 6px;
                            padding: 10px 15px;
                            transition: background 0.2s;
                        }
                        .nav-dropdown-custom .dropdown-item:hover {
                            background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
                        }
                        .navbar-toggler:focus {
                            box-shadow: none;
                        }
                        @media (max-width: 991px) {
                            .navbar-collapse {
                                background: rgba(255,255,255,0.1);
                                border-radius: 10px;
                                padding: 15px;
                                margin-top: 10px;
                            }
                            .nav-dropdown-custom .dropdown-menu {
                                background: rgba(255,255,255,0.95);
                            }
                            .nav-dropdown-custom .dropdown-toggle {
                                width: 100%;
                                justify-content: space-between;
                            }
                        }
                    `}</style>
                </>
            )}
        </AppContext.Consumer>
    );
}
